<template>
  <div class="default-engineering-modules-header w-100">
    <b-row>
      <b-col
        v-if="shouldShowTitle"
        class="default-engineering-modules-header__column-title"
      >
        <h1>
          {{ title }}
        </h1>
        <h3
          v-if="shouldShowSubtitle"
        >
          {{ subtitle }}
        </h3>
      </b-col>
    </b-row>
    <b-row
      class="default-engineering-modules-header__row-asset-data"
    >
      <b-col
        sm="10"
      >
        <default-data-header
          :items="items"
        />
      </b-col>
      <b-col
        sm="2"
      >
        <icons-header
          :show-update-icon="showUpdateIcon"
          :show-wifi-icon="showWifiIcon"
          :show-info-icon="showInfoIcon"
          :show-treeview-icon="showTreeviewIcon"
          :show-print-icon="showPrintIcon"
          :update-event="this.updateEvent"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DefaultDataHeader from '@/components/header/DefaultDataHeader';
import IconsHeader from '@/components/header/IconsHeader';
import IconsHeaderMixin from '@/components/header/mixin/iconsHeaderMixin';
import AssetDataHeaderMixin from '@/components/header/mixin/assetDataHeaderMixin';
import EngineeringModulesHeaderMixin from '@/components/header/mixin/engineeringModulesHeaderMixin';

export default {
  components: {
    DefaultDataHeader,
    IconsHeader,
  },
  mixins: [
    IconsHeaderMixin,
    AssetDataHeaderMixin,
    EngineeringModulesHeaderMixin,
  ],
};
</script>

<style lang="sass" scoped>
  .default-engineering-modules-header
    position: relative
    &::after
      position: absolute
      content: ''
      border-bottom: 2px solid var(--color-border-gray)
      display: block
      width: 100%
      z-index: 1
      margin-right: -1rem
    &__row-asset-data
      margin-top: 20px
    &__column-title
      display: flex
      align-items: baseline
      & h3
        margin-left: 1rem
    &__column-icons
      display: flex
      justify-content: flex-end;
      & button
        border: none
        background-color: transparent
</style>
